import React, { useState } from 'react';
import { Button, Flex, Modal } from 'antd';
import { UploadOutlined } from '@ant-design/icons';

import FormWithDescription from '../FileWithDescription';

import { getRandomId } from '../../utilities/randomId';

const AttachmentModal = ({ row, action, parentKey, title = '', status, isMandatory = false }) => {
  const [currentInfo, setCurrentInfo] = useState(row[parentKey]?.info ?? []);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => setIsModalOpen(true);
  const handleOk = () => {
    action({
      ...row,
      [`${parentKey}`]: { ...row[`${parentKey}`], info: [...currentInfo] }
    });
    setIsModalOpen(false);
  };
  const handleCancel = () => setIsModalOpen(false);

  const addNewInfo = () =>
    setCurrentInfo((prev) => [
      ...prev,
      {
        id: getRandomId(),
        details: '',
        attachment: []
      }
    ]);

  const removeInfo = (id) => {
    setCurrentInfo((prev) => [...prev.filter((item) => item.id !== id)]);
  };

  const updateInfo = (updatedItem) => {
    const index = currentInfo.findIndex((item) => item.id === updatedItem.id);

    if (index === -1) return;

    const newItems = [...currentInfo];
    newItems[index] = { ...newItems[index], ...updatedItem };

    setCurrentInfo(newItems);
  };

  return (
    <>
      <Flex>
        <Button type="primary" onClick={showModal} disabled={status === 1 || status === 2 || status === 3}>
          <UploadOutlined />
          {/* {title && ` ${title}`}    */}
        </Button>
        {isMandatory && <span style={{ color: 'red', marginLeft: '4px', fontSize: 20, marginTop: -10 }}>*</span>}
      </Flex>
      <Modal
        title={title}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="Save"
        closable={false}
        disabled={status === 1 || status === 2 || status === 3}
      >
        {currentInfo.map((item, index) => (
          <FormWithDescription
            index={index}
            key={item.id}
            id={item.id}
            removeAction={removeInfo}
            row={item}
            action={updateInfo}
            parentKey={parentKey}
          />
        ))}

        <br />
        <Button
          onClick={() => {
            addNewInfo();
          }}
        >
          Add Description
        </Button>
      </Modal>
    </>
  );
};

export default AttachmentModal;
